export default "__VITE_ASSET__eb9e6de5__"